// project import
import pages from './pages';
import dashboard from './dashboard';
import utilities from './utilities';
import support from './support';

// ==============================|| MENU ITEMS ||============================== //
const menuItemsArray = [dashboard, pages, utilities, support];
const menuItems = {
    items: menuItemsArray
};

export default menuItems;
